import { AssetQualityLevel, IResourcesGroupConfig } from "@nolimitcity/slot-game/bin/asset/Asset";
import { BitmapFontAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import { TextureAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import { SpineAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class GameAssets {

    public static BITMAP_FONT_WIN_COUNT_UP_LOW:string = "NumbersWinCountUp";

    public static BITMAP_FONT_FS_NUMBERS:string = "FS_Numbers";

    public static BITMAP_FONT_COLLECTOR:string = "Collector";
    
    public static BITMAP_FONT_MULTIPLIER:string = "NumbersMultiplier";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";

    public static INTRO_BACKGROUND:string = "introBackground";
    public static INTRO_LOGO:string = "introLogo";

    public static NORMAL_REEL_DIVIDER:string = "reelDivider";
    public static NEAR_WIN_REEL_DIVIDER:string = "reelDividerNearWin";

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],
        main : [
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {}
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json"),
                    new TextureAsset("mainJpeg12", "sheets/mainJpeg/mainJpeg12.json"),
                    new TextureAsset("mainJpeg13", "sheets/mainJpeg/mainJpeg13.json")
                    
                ],
                animations: {
                    "winFrame" : "Win_Frame/Win_Frame_",
                    "Win_FX": "Win_FX/Win_FX_",
                    "Win_Fire_Frame": "Win_Fire_Frame/F_Frame_",
                    "Win_Fire_Frame_Loop": "Win_Fire_Frame_Loop/F_Frame_Loop_",
                    "FX_Speedlines" : "FX_Speedlines/Speedlines_",
                    "Cone_Particle" : "BW_Particles/Cone_SEQ/Cone_",
                    "Wheel_Particle" : "BW_Particles/Wheel_SEQ/Wheel_",
                    "Wunder_Particle" : "BW_Particles/Wunder_SEQ/Wunder_",

                    
                }
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json")
                    
                    
                    
                ],
                animations : {
                    "M_108_Reveal": "M_108_Spin/M_108_Spin_",
                    "M_126_Reveal": "M_126_Spin/M_126_Spin_",
                    "M_144_Reveal": "M_144_Spin/M_144_Spin_",
                    "Respin" : "Respin/respin_",
                    "FX_StickySplash": "FX_StickySplash/FX_StickySplash_"
                }
            },
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_MULTIPLIER, "fonts/bitmapfonts/NumbersMultiplier.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_FS_NUMBERS, "fonts/bitmapfonts/FS_Numbers.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_COLLECTOR, "fonts/bitmapfonts/Collector.fnt"),
                ]
            },
            {
                name:"spine",
                assets:[
                    new SpineAsset("FS_Intro", "spine/FS_Intro.json"),
                    new SpineAsset("WILD", "spine/Wild.json"),
                    new SpineAsset("Speech", "spine/Speech_Bubble.json"),
                    new SpineAsset("Reel_FX", "spine/Reel_FX.json"),
                    new SpineAsset("Win_FX_spine", "spine/Win_FX.json"),
                    new SpineAsset("Big_Win", "spine/Big_Win.json"),
                    new SpineAsset("F5", "spine/F5.json"),
                    new SpineAsset("F6", "spine/F6.json"),
                    new SpineAsset("F7", "spine/F7.json"),
                    new SpineAsset("Wild_Reveal", "spine/W_Reveal.json"),
                    new SpineAsset("Next", "spine/Next.json"),
                    new SpineAsset("Random_Intro", "spine/Random_Intro.json"),
                    new SpineAsset("M_Landing", "spine/M_Landing.json"),
                    new SpineAsset("Win_Cap", "spine/Win_Cap.json"),
                    new SpineAsset("BG", "spine/BG.json"),
                    new SpineAsset("Wild_Indicator", "spine/Wild_Indicator.json"),
                    new SpineAsset("Police_FS", "spine/Police_FS.json")
                ]
            },
        ]
    };
}
